import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Radio, LogOut, Plus, Settings, BookOpen, Library } from "lucide-react";

export default function TeacherDashboard() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [packs, setPacks] = useState([]);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get("/packs").then((r) => setPacks(r.data)).catch((e) => setErr(formatErr(e)));
  }, []);

  return (
    <div className="min-h-screen dark bg-[#070B14] text-white">
      <header className="border-b border-white/5 px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <div className="h-8 w-8 rounded-lg bg-gradient-to-br from-cyan-400 to-violet-500 flex items-center justify-center">
            <Radio className="h-4 w-4 text-black" />
          </div>
          <span className="font-heading font-bold">Şarkı Söyleyen Deyimler</span>
        </Link>
        <div className="flex items-center gap-4">
          <Link to="/deyimler" className="text-sm text-zinc-400 hover:text-cyan-300 flex items-center gap-2" data-testid="dashboard-showcase-link">
            <Library className="h-4 w-4" /> Deyim Vitrini
          </Link>
          <Link to="/rehber" className="text-sm text-zinc-400 hover:text-cyan-300 flex items-center gap-2 hidden sm:inline-flex" data-testid="dashboard-guide-link">
            <BookOpen className="h-4 w-4" /> Rehber
          </Link>
          <Link to="/admin/content" className="text-sm text-zinc-400 hover:text-white flex items-center gap-2" data-testid="admin-link">
            <Settings className="h-4 w-4" /> İçerik Yönetimi
          </Link>
          <span className="text-sm text-zinc-500 hidden sm:inline">{user?.email}</span>
          <button onClick={() => { logout(); nav("/"); }} className="text-sm text-zinc-400 hover:text-white flex items-center gap-2" data-testid="logout-btn">
            <LogOut className="h-4 w-4" /> Çıkış
          </button>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-6 py-12">
        <h1 className="font-heading text-4xl font-bold">Canlı Oyun Başlat</h1>
        <p className="text-zinc-400 mt-2">Bir paket seç ve sınıfını oyuna davet et.</p>

        {err && <div className="mt-4 text-red-300 text-sm">{err}</div>}

        <div className="mt-10 grid md:grid-cols-3 gap-5">
          {packs.map((p) => (
            <button
              key={p.key}
              onClick={() => nav(`/teacher/create/${p.key}`)}
              data-testid={`pack-${p.key}`}
              className="text-left rounded-3xl border border-white/10 bg-zinc-950/70 hover:border-cyan-400/60 hover:shadow-[0_0_40px_-15px_rgba(5,217,232,0.5)] transition p-6"
            >
              <div className="text-xs font-heading tracking-widest text-cyan-300">PAKET</div>
              <div className="mt-2 font-heading text-2xl font-bold">{p.name}</div>
              <div className="text-zinc-400 text-sm mt-3">{p.description}</div>
              <div className="mt-6 text-zinc-500 text-xs">
                <span className="text-white font-medium">{p.published_count}</span> yayında deyim
              </div>
              <div className="mt-4 inline-flex items-center gap-2 text-cyan-300">
                <Plus className="h-4 w-4" /> Oyun oluştur
              </div>
            </button>
          ))}
        </div>
      </main>
    </div>
  );
}
